import styled from 'styled-components';

const ToolbarContainer = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
`;

export default ToolbarContainer;
